import React, { useState } from 'react';
import {
  Button,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
  HStack,
  PinInput,
  PinInputField,
} from '@chakra-ui/react';

import { checkVoucher } from '../api';

function VoucherInput({ onVoucher }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const [code, setCode] = useState();
  const [voucher, setVoucher] = useState();
  const [error, setError] = useState();

  //   const insertCodeHandler = (event) => {
  //     setError();
  //     setVoucher();
  //     setCode(event.target.value.toUpperCase());
  //   };
  const insertCodeHandler = (value) => {
    setError();
    setVoucher();
    setCode(value.toUpperCase());
  };
  const checkVoucherHandler = async () => {
    setIsLoading(true);
    const res = await checkVoucher(code);
    // console.log(res);
    if (res.success) {
      setVoucher(res.data);
    } else {
      setError(res.error);
    }
    setIsLoading(false);
  };

  return (
    <>
      <Button
       variant='secondary'
        onClick={() => {
          setCode();
          setError();
          setVoucher();
          onOpen();
        }}
      >
        VOUCHER
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        closeOnOverlayClick={false}
        blockScrollOnMount={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Voucher</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Inserisci il codice del voucher</Text>
            <HStack my={5}>
              <PinInput value={code} type='alphanumeric' onChange={insertCodeHandler}>
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
                <PinInputField />
              </PinInput>
            </HStack>
            {/* <Input my={5} value={code} onChange={insertCodeHandler} placeholder='.....' size='sm' /> */}
            {voucher && (
              <Text fontWeight={600} color='gold'>
                Voucher valido: {voucher.value}
                {voucher.type === 'euro' ? '€' : '%'}
              </Text>
            )}
            {error && <Text color='tomato'>{error}</Text>}
          </ModalBody>

          <ModalFooter>
            {/* <Button isLoading={isLoading} minWidth={125} mr={3} onClick={onClose}>
              Annulla
            </Button> */}
            <Button
              mr={3}
              isLoading={isLoading}
              //   minWidth={125}
              isDisabled={!voucher}
              onClick={() => {
                onVoucher(voucher);
                onClose();
              }}
            >
              Applica Voucher
            </Button>
            <Button
              isLoading={isLoading}
              //   minWidth={125}
              isDisabled={!code}
              onClick={checkVoucherHandler}
            >
              Verifica
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default VoucherInput;
